const trapFocusHandlers = {};
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}
 // Trap focus related components
 const getFocusableElements = (container) =>
 Array.from(
   container.querySelectorAll(
     "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
   )
 ).filter((el) => {
   // Find all parent elements for this node
   const elParents = [
     // eslint-disable-next-line func-names
     ...(function* (e) {
       // eslint-disable-next-line no-cond-assign
       while ((e = e.parentNode)) {
         yield e;
       }
     })(el),
   ];
   // Remove html and body tags from node list
   elParents.splice(elParents.length - 2, 2);
   // Find any parent that is currently hidden via display: none;
   const hiddenParent = elParents.find((parent) => window.getComputedStyle(parent, null).display === 'none');
   const hiddenParentInline = elParents.find((parent) => parent.style.display === 'none');
   const hiddenCSS = window.getComputedStyle(el, null).display === 'none';
   const hiddenInline = el.style.display === 'none';
   // filter out elements that are hidden;
   return !hiddenParent && !hiddenParentInline && !hiddenCSS && !hiddenInline;
});
const trapFocus = (container, elementToFocus = container) => {
 const elements = getFocusableElements(container);
 const first = elements[0];
 const last = elements[elements.length - 1];
 removeTrapFocus();
 trapFocusHandlers.focusin = (event) => {
   if (event.target !== container && event.target !== last && event.target !== first) return;
   document.addEventListener('keydown', trapFocusHandlers.keydown);
 };
 trapFocusHandlers.focusout = () => {
   document.removeEventListener('keydown', trapFocusHandlers.keydown);
 };
 trapFocusHandlers.keydown = (event) => {
   if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
   // On the last focusable element and tab forward, focus the first element.
   if (event.target === last && !event.shiftKey) {
     event.preventDefault();
     first.focus();
   }
   //  On the first focusable element and tab backward, focus the last element.
   if ((event.target === container || event.target === first) && event.shiftKey) {
     event.preventDefault();
     last.focus();
   }
 };
 document.addEventListener('focusout', trapFocusHandlers.focusout);
 document.addEventListener('focusin', trapFocusHandlers.focusin);
 elementToFocus.focus();
};
const focusVisiblePolyfill = () => {
 const navKeys = [
   'ARROWUP',
   'ARROWDOWN',
   'ARROWLEFT',
   'ARROWRIGHT',
   'TAB',
   'ENTER',
   'SPACE',
   'ESCAPE',
   'HOME',
   'END',
   'PAGEUP',
   'PAGEDOWN',
 ];
 let currentFocusedElement = null;
 let mouseClick = null;
 window.addEventListener('keydown', (event) => {
   if (navKeys.includes(event.code.toUpperCase())) {
     mouseClick = false;
   }
 });
 window.addEventListener('mousedown', () => {
   mouseClick = true;
 });
 window.addEventListener(
   'focus',
   () => {
     if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
     if (mouseClick) return;
     currentFocusedElement = document.activeElement;
     currentFocusedElement.classList.add('focused');
   },
   true
 );
};
const removeTrapFocus = (elementToFocus = null) => {
 document.removeEventListener('focusin', trapFocusHandlers.focusin);
 document.removeEventListener('focusout', trapFocusHandlers.focusout);
 document.removeEventListener('keydown', trapFocusHandlers.keydown);
 if (elementToFocus) elementToFocus.focus();
};
const getVisibleElements = (elements) => {
  return Array.from(elements).filter(element =>
    window.getComputedStyle(element).getPropertyValue('display') != 'none'
 );
}
export {trapFocus, removeTrapFocus, getVisibleElements}